import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";
import dowmLine from "../../../assets/img/down-line.svg";

export const NavBarContainer = styled.div`
  display: flex;
  max-width: 1280px;
  margin: 50px auto 50px;
  justify-content: space-between;
`;
export const TitleContainer = styled.div`
  /* width: 50%; */
  font-size: 24px;
`;

export const LinksContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  font-weight: 600;
`;

export const LinkText = styled.div`
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: #777E91;
  &:after {
    content: "";
    width: 16px;
    height: 16px;
    background-image: url(${dowmLine});
    background-size: 23px;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    right: -35px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const StyledNavLink = styled(NavLink)`
  margin-left: 35px;
  text-decoration: none;
  position: relative;
`;
